module.exports = __webpack_public_path__ + "img/calendario.11d58b8e.svg";